module.exports = {

    props: {
        project: {
            type: Object,
            required: true,
        },
        space: {
            type: Object,
            required: true,
        },
        forms: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            formsInSelectedSpace: this.space.forms,
        }
    },

    methods: {
        openForm(form) {
            this.redirectTo(`/projects/${this.project.slug}/spaces/${this.space.slug}/form/${form.slug}/${form.test.id}`)
        }
    },

    created() {
        App.bus.$on('refresh-space-areas', space => {
            this.formsInSelectedSpace = space.forms;
        })
    }
}
